<div class="list-fields-form">
  <!-- Header Row with Add Button -->
  <div class="list-header">
    <div class="header-content">
      <span class="header-label">Year</span>
      <span class="header-label">Date from</span>
      <span class="header-label" *ngIf="isColumnVisible('dateTill')">Date till</span>
      <span class="header-label">Day off</span>
      <span class="header-action">
        <button type="button"
                class="btn btn-secondary btn--sm cs-pointer"
                (click)="addRow()"
                [disabled]="!canAddRow()"
                [matTooltip]="canAddRow() ? 'Add row' : 'All years are already added'">
          <i class="mdi mdi-plus"></i>
        </button>
      </span>
    </div>
  </div>

  <!-- Scrollable Content -->
  <div class="list-content">
    <div
      *ngFor="let rowGroup of rows.controls; let i = index; trackBy: trackByIndex"
      class="list-row"
    >
      <div class="row-content">
        <!-- Year Dropdown -->
        <div class="form-group">
          <select
            [id]="'year-' + i"
            class="form-control"
            [formControl]="rowGroup.get('year')"
            (change)="onYearChange(i, $any(rowGroup.get('year').value))"
          >
            <option value="">--</option>
            <option *ngFor="let year of yearOptions" [value]="year" [disabled]="isYearDisabled(year, i)">
              {{ year }}
            </option>
          </select>
          <div class="pm-form-element-invalid-feedback" *ngIf="shouldShowRowErrors(i) && getRowErrors(i)?.yearRequired">
            <small class="invalid">Year is required</small>
          </div>
          <div class="pm-form-element-invalid-feedback" *ngIf="shouldShowRowErrors(i) && getRowErrors(i)?.yearOutOfRange">
            <small class="invalid">Year is out of range</small>
          </div>
        </div>

        <!-- Date From -->
        <div class="form-group">
          <cs-datepicker-plain [formControl]="rowGroup.get('dateFrom')"
                               [attr.id]="'dateFrom-' + i"
                               #dp="picker"
                               [disabled]="readOnly"
                               [minDate]="getYearForRow(i) ? {year: getYearForRow(i), month: 1, day: 1} : null"
                               [maxDate]="getYearForRow(i) ? {year: getYearForRow(i), month: 12, day: 31} : null"
                               (selectionChanged)="onDateFromChange(i, $event)"
          ></cs-datepicker-plain>
          <div
            class="pm-form-element-invalid-feedback"
            *ngIf="shouldShowRowErrors(i) && getRowErrors(i)?.dateFromRequired"
          >
            <small class="invalid">Date from is required</small>
          </div>
        </div>

        <!-- Date Till -->
        <div class="form-group" *ngIf="isColumnVisible('dateTill')">
          <cs-datepicker-plain [formControl]="rowGroup.get('dateTill')"
                               [attr.id]="'dateTill-' + i"
                               #dp="picker"
                               [disabled]="readOnly"
                               [minDate]="getYearForRow(i) ? {year: getYearForRow(i), month: 1, day: 1} : null"
                               [maxDate]="getYearForRow(i) ? {year: getYearForRow(i), month: 12, day: 31} : null"
          ></cs-datepicker-plain>
          <div
            class="pm-form-element-invalid-feedback"
            *ngIf="shouldShowRowErrors(i) && getRowErrors(i)?.dateTillRequired"
          >
            <small class="invalid">Date till is required</small>
          </div>
          <div
            class="pm-form-element-invalid-feedback"
            *ngIf="shouldShowRowErrors(i) && getRowErrors(i)?.dateRangeInvalid"
          >
            <small class="invalid">Date from must be before date till</small>
          </div>
        </div>

        <!-- isDayoff Checkbox -->
        <div class="form-group form-check-wrapper">
          <cs-checkbox
            [formControl]="rowGroup.get('isDayoff')"
            [name]="'isDayoff' + i"
            [id]="'isDayoff-' + i"
          ></cs-checkbox>
        </div>

        <!-- Delete Button -->
        <div class="form-group delete-field">
          <button
            type="button"
            class="btn btn-secondary btn--sm cs-pointer"
            (click)="removeRow(i)"
            title="Delete row"
          >
            <i class="mdi mdi-delete"></i>
          </button>
        </div>
      </div>

      <!-- Divider -->
      <div *ngIf="i < rows.length - 1" class="divider"></div>
    </div>
  </div>
</div>
